export const formatNumber = (num: number): string => {
  if (num >= 1000000) return `${(num / 1000000).toFixed(1)}M`
  if (num >= 1000) return `${(num / 1000).toFixed(1)}K`
  return num.toString()
}

export const getResourceBadgeVariant = (
  isCritical: boolean,
  isLow: boolean
): 'destructive' | 'secondary' | 'outline' => {
  if (isCritical) return 'destructive'
  if (isLow) return 'secondary'
  return 'outline'
}
